module.exports = __webpack_public_path__ + "img/discord.7bb34993.svg";